import {Layouts} from '@/enum';
class LayoutManager {
    constructor(currentLayout) {
        this.setLayout(currentLayout);
        this.resetLayout(); // this resets all possible previous layout variables
    }
    setLayout(currentLayout) {
        const {name} = currentLayout;
        const layoutDefinition = Layouts.find(item => item.name === name);
        if(!layoutDefinition) {
            throw new Error('layout with definition ' + name + ' not found')
        }
        console.log('layoutDef', layoutDefinition)
        const {defaults, positions} = JSON.parse(JSON.stringify(layoutDefinition));
        this.defaults = defaults;
        this.positions = positions;
        this.currentLayout = currentLayout;
        console.log('LayoutManager initialized');
    }
    getLayoutPositions() {
        return this.positions;
    }
    getPanelOptionsPos(uuid) {
        const pos = this.getPanelPositionName(uuid);
        const comparePos = pos ? pos.toLowerCase() : '';
        if(comparePos.includes('top')) {
            return 'bottom';
        } else if(comparePos.includes('bottom')) {
            return 'top';
        } else if(comparePos.includes('left')) {
            return 'right';
        } else if(comparePos.includes('right')) {
            return 'left';
        } else {
            return 'left';
        }
    }
    getPanelPositionName(uuid) {
        const {positions} = this.currentLayout;
        const keys = Object.keys(positions);
        for(let i = 0; i < keys.length; i++) {
            const value = positions[keys[i]];
            if(value && value.panelId === uuid) {
                return value.name;
            }
        }
        return null;
    }
    resetLayout() {
        const defaultVars = this.defaults.RESET;
        this.setDefaultVars(defaultVars.vars);
    }
    setDefaultVars(vars) {
        const keys = Object.keys(vars);
        // those are variables like --top-bar-height that need to be set globally
        for(let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = vars[key];
            document.documentElement.style.setProperty(key, value);
        }
    }
    getPositionConstant(positionName) {
        const values = Object.values(this.positions);
        const index = values.indexOf(positionName);
        const keys = Object.keys(this.positions);
        return keys[index];
    }
    getPositionStyle(position, isPreview = false) {
        const positionConstant = this.getPositionConstant(position);
        /*if(!positionConstant) {
            console.log('Unable to find position ', position)
            throw new Error('Unable to find position ' + position);
        }*/
        console.log('getting def style for', positionConstant, position);
        let defaultStyle = this.defaults[positionConstant];
        if(!defaultStyle.vars) {
            defaultStyle.vars = {};
        }
        defaultStyle.vars['--inbuilt-bottom-bar-height'] = '60px'; // this is the built in bottom bar, set to 0 if
        defaultStyle.vars['--sidebar-spacing'] = '10px';
        if(defaultStyle.vars) {
            this.setDefaultVars(defaultStyle.vars);
        }
        delete defaultStyle.vars;
        let style = {
            ...defaultStyle,
            position: 'absolute',
        };
        if(position.includes('top') || position.includes('bottom')) {
            style.zIndex = '5';
        }
        if(isPreview) {
            style = {
                ...defaultStyle,
                position: 'absolute',
                outline: '1px dashed white',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '3px',
            }
        }
        return style;
    }
}

export default LayoutManager;